import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgIcon } from '@ng-icons/core';
import { Button } from 'excellence-ui';

@Component({
  selector: 'app-dashboard-help-center-card',
  imports: [NgIcon, Button, TranslocoPipe, RouterLink],
  templateUrl: './dashboard-help-center-card.html',
})
export class DashboardHelpCenterCard {}
